var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreIpo = function SvgPreIpo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 1v12A9 9 0 1 1 7.375 5.278L14 1.453v2.77zm-9 5.66a6.34 6.34 0 1 0 0 12.68 6.34 6.34 0 0 0 0-12.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.858 13.062a.03.03 0 0 1 .02-.003c.756.197 1.122.673 1.122 1.41 0 1.184-.994 1.826-2.845 1.826H9V15.16l1.638-1.1c.017-.011.04 0 .04.021v.93h1.741q.876 0 .876-.66a.59.59 0 0 0-.406-.587c-.02-.008-.024-.035-.006-.047zM12.182 9.871c1.205 0 2.006.314 2.355.907a.025.025 0 0 1-.008.034l-1.454.976a.011.011 0 0 1-.017-.01l-.004-.068c-.034-.356-.301-.563-.735-.563h-1.641v1.072a.03.03 0 0 1-.012.022L9.04 13.333A.025.025 0 0 1 9 13.312v-3.44z"
  })));
};
export default SvgPreIpo;